import React from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';

interface RemoveFallbackRateModalProps {
  isOpen;
  onClose;
  onDeleteSuccess;
}
export const RemoveFallbackRateModal: React.FC<RemoveFallbackRateModalProps> = ({
  isOpen,
  onClose,
  onDeleteSuccess,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="remove-fallback-rate-modal">
        <h2 className="remove-fallback-rate-modal__title">Turn off fallback rate?</h2>
        <div className="remove-fallback-rate-modal__content">
          <p>
            The fallback rate ensures customers ordering always have a shipping option available even if their order
            doesn’t match any of your delivery methods. Turning it off might stop some customers from checking out.{' '}
          </p>
        </div>
        <div className="remove-fallback-rate-modal__actions">
          <Button
            onClick={onClose}
            text={'Cancel'}
            size={'medium'}
            variant={'secondary'}
            className="remove-fallback-rate-modal__actions__cancel"
          />
          <Button onClick={onDeleteSuccess} text={'Turn off'} size={'medium'} variant={'primary'} />
        </div>
      </div>
    </Modal>
  );
};
